import type { Quality } from '../types'

/**
 * Shadow enablement is a deliberate, stable setting. Adaptive quality can lower
 * resolution, bloom, and decorative detail, but changing shadowMap.enabled at
 * runtime recompiles every lit material and invalidates the frozen shadow map.
 */
export function shouldEnableShadows(manualShadowsEnabled: boolean, quality: Quality): boolean {
  return manualShadowsEnabled && quality !== 'low'
}
